<template>
  <div class="page px-3" v-if="visible">
    <div>
      <h4 class="function-title">Nuevas Empresas Asociadas</h4>
    </div>
    <b-row>
      <b-col sm="8" offset-sm="2">
        <b-row>
          <b-col class="text-left" sm="6">
            <b-btn variant="primary" @click="agregarEmpresaAsociada">
              <i class="fas fa-plus"></i> Agregar Empresa
            </b-btn>
          </b-col>
          <b-col class="text-right" sm="6">
            <b-btn variant="danger" @click="cerrarNuevasEmpresasAsociadas">
              <i class="fas fa-times"></i> Cerrar
            </b-btn>
          </b-col>
        </b-row><br>
        <b-row>
          <b-col sm="12">
            <br><p class="text-primary" v-if="empresasAsociadas.length > 0">
              <b>Empresas Asociadas a esta póliza:</b>
              <v-select
                multiple
                v-model="empresasElegidas"
                label="text"
                class="mt-2"
                :options="empresasAsociadas"
                :reduce="empresasAsociadas => empresasAsociadas.value"
              ></v-select>
            </p>
          </b-col>
              Cantidad de empresas seleccionadas: {{ empresasElegidas.length }}
        </b-row>
        <div class="submit-footer">
          <b-row>
            <b-col></b-col>
            <b-col class="text-right">
              <b-btn variant="primary" @click="enviarEmpresasElegidas" :disabled="!empresasElegidas.length">
                <i class="fa fa-check"></i>
                Aceptar nuevas empresas asociadas
              </b-btn>
            </b-col>
          </b-row>
        </div>
        <br><br>
      </b-col>
    </b-row>

    <!-- Este modal de empresas asociadas -->
    <b-modal v-model="show"  ref="modal" :title="nuevasEmpresasAsociadasTitulo">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Razón Social">
            <b-form-input
              type="text"
              v-model="form.razonSocial"
              @blur="$v.form.razonSocial.$touch"
              :state="$v.form.razonSocial.$dirty ? !$v.form.razonSocial.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="CUIT">
            <b-form-input
              type="text"
              min="11"
              max="11"
              v-model="form.cuit"
              v-mask="'##-########-#'"
              @blur="$v.form.cuit.$touch"
              :state="$v.form.cuit.$dirty ? !$v.form.cuit.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Dirección">
            <b-form-textarea
              type="text"
              v-model="form.direccion"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="submit" :disabled="$v.form.$invalid">
          {{ botonSubmit }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Salir
        </b-button>
      </template>

    </b-modal>

  </div>
</template>

<script>
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

export default {
  props: {
    nroPoliza: {
      type: Number | String
    }
  },

  data() {
    return {
      visible: false,
      empresasAsociadas: [],
      empresasElegidas: [],
      show: false,
      nuevasEmpresasAsociadasTitulo: '',
      botonSubmit: '',
      form: {}
    };
  },
  validations: {
    form: {
      razonSocial: { required },
      cuit: { required,
              minLength: minLength(13),
              maxLength: maxLength(13)
            },
    }
  },
  methods: {
    identificadorUsuario(){
      if (this.$store.state.auth.cod_agente && this.$store.state.auth.cod_agente != '')
        return this.$store.state.auth.cod_agente;
      else 
        return this.$store.state.auth.email;
    },
    obtenerEmpresasAsociadas(){
      const user = this.identificadorUsuario();
      this.$api(`clasula-no-repeticion/empresas-asociadas-by-agent/${user}`).then(res => {
        this.empresasAsociadas = res.data.map(item => ({
          text: item.razon_social + ' | CUIT: ' + item.cuit,
          value: [item.razon_social, item.cuit, item.direccion]
        }));
      });
    },
    cerrarNuevasEmpresasAsociadas(){
      this.$emit('cerrar', true)
    },
    agregarEmpresaAsociada(){
      this.nuevasEmpresasAsociadasTitulo = 'Asociar nueva empresas'
      this.form = {}
      this.botonSubmit = 'Asociar'
      this.show = true
    },
    submit() {
      this.$v.form.$touch();

      if (this.$v.form.$invalid) {
        return null
      }

      let empresaYaAsociada = this.empresasAsociadas.filter(e => e.value[1] == this.form.cuit)
      if (empresaYaAsociada.length > 0) {
        this.$toast.error('¡Error! ¡El cuit ingresado ya pertenece a una empresa asociada!')
        return null
      }

      const payload = {
        nombre: this.form.razonSocial,
        cuit: this.form.cuit,
        direccion: this.form.direccion ? this.form.direccion : '-',
        productor: this.identificadorUsuario(),
        // poliza: this.nroPoliza
      };
      //console.log("se ve esto en cod_agente"+this.$store.state.auth.cod_agente);
        return this.$api.post(`clasula-no-repeticion/empresas-asociadas/asociar`, payload).then(res => {
          this.obtenerEmpresasAsociadas()
          this.show = false
          this.$toast.success('Se ha asociado correctamente una nueva empresa.')
        }).catch((err) => {
          this.show = false
          this.$toast.error('Ocurrió un error al enviar la solicitud para asociar la empresa.');
          //console.log(err.response);
        });

    },
    enviarEmpresasElegidas(){
      this.$emit('enviar', this.empresasElegidas)
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.obtenerEmpresasAsociadas()
      }
    }
  }
};
</script>
